module.exports = __webpack_public_path__ + "static/img/jp4.34cb71bb.png";